<template>
    <v-dialog v-model="open" :max-width="'90%'" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="obModal.titulo"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <v-container fluid grid-list-sm>

                        <v-row dense>
                            <v-col cols="12" :sm="isNatural ? 3 : 4">
                                <v-autocomplete label="Tipo Persona *" color="textbox" v-model="obForm.idTipoPersona"
                                    item-value="idTipoPersona" item-text="tipoPersona" :disabled="_.size(obForm.idCliente) > 0"
                                    :items="_.filter(listGeneral.listTipoPersona,{'visualiza':'true'})" outlined
                                    dense @change="reset"/>
                            </v-col>
                            <v-col cols="12" sm="3" v-if="isNatural">
                                <v-autocomplete label="Tipo Documento *" color="textbox"
                                    v-model="obForm.idTipoDocumento" item-value="idTipoDocumento"
                                    item-text="tipoDocumento" :disabled="_.size(obForm.idCliente) > 0"
                                    :items="_.filter(listGeneral.listTipoDocumento,{'visualiza':'true'})" outlined
                                    dense @change="reset"/>
                            </v-col>
                            <v-col cols="12" sm="3" v-if="isNatural">
                                <v-form ref="form_RC">
                                    <v-text-field label="N° Documento *" v-model="obForm.nroDocumento"
                                        :rules="_.concat(requeridoRegla,isCedula ? cedula : ruc)" outlined 
                                        dense :disabled="_.size(obForm.idCliente) > 0"
                                        color="textbox"/>
                                </v-form>
                            </v-col>
                            <v-col cols="12" sm="3" v-if="isNatural && _.size(obForm.idCliente) == 0">
                                <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-btn fab dark small color="primary" v-show="isCedula"
                                            @click="onConsultarRegistroCivil" v-on="on" :disabled="disabled">
                                            <v-icon dark>search</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Buscar</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>

                        <v-row dense v-if="isNatural">
                            <v-col cols="12" sm="12">
                                <ModalClienteNaturalComponent :obModal="obForm" :listGeneral="listGeneral"
                                    :parametros="parametros" :isCedula="isCedula" />
                            </v-col>
                        </v-row>

                        <v-row dense v-else>
                            <v-col cols="12" sm="12">
                                <ModalClienteJuridicaComponent :obModal="obForm" :listGeneral="listGeneral"
                                    :parametros="parametros" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalClienteComponent',
        components: {
            ModalClienteNaturalComponent: () => import('@/components/catalogo/ModalClienteNaturalComponent.vue'),
            ModalClienteJuridicaComponent: () => import('@/components/catalogo/ModalClienteJuridicaComponent.vue')
        },
        inject: ['onClose'],
        props: {
            open: {
                type: Boolean,
                default: false
            },
            obModal: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            }
        },
        data: () => ({
            openFecNac: false,
            openFecMat: false,
            disabled: false,
            obForm: {}
        }),
        watch: {
            open(val) {
                if (val) {
                    this.$set(this,'obForm',this.obModal);
                }
            }
        },
        computed: {
            isNatural() {
                var idTipoPersona = _.get(this.obForm, 'idTipoPersona', 0);
                return _.toNumber(idTipoPersona) != _.toNumber(this.parametros.id_tipo_persona_juridica) ? true : false;
            },
            isCedula() {
                var idTipoDocumento = _.get(this.obForm, 'idTipoDocumento', 0);
                return _.toNumber(idTipoDocumento) == _.toNumber(this.parametros.id_tipo_doc_cedula) ? true : false;
            }
        },
        methods: {
            reset(event){
                if(!_.isUndefined(event)){
                    var keys = ['open','titulo','idTipoPersona','idTipoDocumento','nroDocumento','idEstado'];
                    _.forEach(_.cloneDeep(this.obForm),(v,k)=>{ 
                        if(!_.includes(keys,k))
                            _.set(this.obForm,k,null); 
                    });
                    this.$refs.form.resetValidation();
                }
            },
            onListar(event) {
                if (!_.isUndefined(event)) {

                }
            },
            onConsultarRegistroCivil(event) {
                if (!_.isUndefined(event)) {
                    try {
                        if (!this.$refs.form_RC.validate()) throw mensajeEstandar.corregirInformacion;
                        var error = 'E';
                        this.reset();
                        
                        axios.post(`${BASE_URI}administrador/cliente/buscarClienteWSRegistroCivil`,_.pick(this.obForm,'nroDocumento'))
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    this.obForm = _.merge({},this.obForm,_.omit(r.data.data,['idTipoDocumento','idTipoPersona']));
                                    this.obForm.idEstado = _.size(this.obForm.idEstado) == 0 ? _.toString(this.parametros.id_estado_default) : this.obForm.idEstado;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                            });

                    } catch (ex) {
                        mensajesAlerta(ex, 'I');
                    }
                }
            },
            validar(op) {
                try {
                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                        this.disabled = true;
                        var error = 'E';
                        var o = _.omit(_.cloneDeep(this.obForm),['open','titulo']);
                            o.estado = o.idEstado;
                        var opcion = _.size(o.idCliente) == 0 ? 'I' : 'U';

                        switch (op) {
                            case 1: //Natural
                                var keysNot = ['razonSocial','representanteLegalNombre','representanteLegalDocumento'];
                                var ob = _.merge({},_.omit(o,keysNot),{'opcion':opcion});
                                
                                if(_.size(ob.firma) > 0)
                                    ob.firma = _.get(_.split(ob.firma,','),'1');

                                if(_.size(ob.fotografia) > 0)
                                    ob.fotografia = _.get(_.split(ob.fotografia,','),'1');
                                break;
                            case 2: //Juridica
                                var keys = [
                                                'idCliente','razonSocial','representanteLegalNombre','representanteLegalDocumento',
                                                'idProvincia','idCanton','celular','direccion','telefonoPbx','paginaWeb',
                                                'idEstado','idTipoPersona','nroDocumento'
                                            ];
                                var ob = _.merge({},_.pick(o,keys),{'opcion':opcion});
                                    ob.idEstadoCivil   = this.parametros.id_estado_civil_otros;
                                    ob.idTipoPersona   = this.parametros.id_tipo_persona_juridica;
                                    ob.idTipoDocumento = this.parametros.id_tipo_doc_ruc;
                                    ob.estado = ob.idEstado;
                                break;
                        }
                        ob.idTipoInscripcion = _.size(ob.idCliente) == 0 ? this.parametros.id_tipo_inscripcion_administrador : ob.idTipoInscripcion;

                        axios.post(`${BASE_URI}administrador/cliente/insertOrUpdate`,ob)    
                                .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    setTimeout(() => {
                                        window.location.reload();    
                                    }, 3000);
                                    return true;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                                return false;
                                this.disabled = false;
                            });
                } catch (ex) {
                    mensajesAlerta(ex, 'I');
                    this.disabled = false;
                    return false;
                }
            }
        },
        provide() {
            return {
                validar: this.validar
            }
        }
    }
</script>